const getPublicShareToken = (tokens) => {
  return tokens.find((token) => !token.email);
};

export { getPublicShareToken };
//# sourceMappingURL=getPublicShareToken.js.map
